// extracted by mini-css-extract-plugin
export default {"notice":"notice__4xs9s","title":"title__zfg2-","body":"body__cz7Zg"};